<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80">
    <circle
      cx="40"
      cy="40"
      r="39.75"
      fill="#fff"
      stroke="#BABABF"
      strokeWidth="0.5"/>
    <path
      fill="#850D54"
      stroke="#850D54"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M56.248 59.976L40.692 48.865l-15.555 11.11V24.42a4.444 4.444 0 014.444-4.444h22.222a4.444 4.444 0 014.445 4.444v35.556z"/>
  </svg>
</template>
